
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/DYNAMIC_PAGES/motorcycle-touring/_slug",
      function () {
        return require("private-next-pages/DYNAMIC_PAGES/motorcycle-touring/_slug.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/DYNAMIC_PAGES/motorcycle-touring/_slug"])
      });
    }
  